import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/foundation/api/client";

const AuthContext = createContext(null);

const AUTH_HINT_KEY = "gi_auth_session";  // solo hint client-side (cookie è HttpOnly)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      // C3-B.2.1: evita 401 pre-login sconosciuti. Chiamiamo /auth/me solo se
      // c'è un hint locale (settato al login precedente). Il cookie httponly
      // non è leggibile da JS.
      let hasHint = false;
      try { hasHint = !!localStorage.getItem(AUTH_HINT_KEY); } catch { /* noop */ }
      if (!hasHint) {
        setUser(false);
        setLoading(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        // Sessione scaduta o cookie invalidato: puliamo l'hint
        try { localStorage.removeItem(AUTH_HINT_KEY); } catch { /* noop */ }
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    try { localStorage.setItem(AUTH_HINT_KEY, "1"); } catch { /* noop */ }
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    try { localStorage.removeItem(AUTH_HINT_KEY); } catch { /* noop */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
